module.exports = __webpack_public_path__ + "static/img/ic-106.789e4d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-106.png
// module id = dofr
// module chunks = 1